import { render, staticRenderFns } from "./PublicSiapKerja.vue?vue&type=template&id=838fd24c"
import script from "./PublicSiapKerja.vue?vue&type=script&lang=js"
export * from "./PublicSiapKerja.vue?vue&type=script&lang=js"
import style0 from "./PublicSiapKerja.vue?vue&type=style&index=0&id=838fd24c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports